"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromoModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../../../elements/button/Button");
var _noScroll = require("../../../utils/scroll/noScroll");
var _Modal = require("../../modal/Modal");
var _promoMessagesModule = _interopRequireDefault(require("./promo-messages.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PromoModal = exports.PromoModal = function PromoModal(_ref) {
  var onClose = _ref.onClose,
    promos = _ref.promos,
    productUrl = _ref.productUrl;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal, {
    className: _promoMessagesModule.default.promo__modal,
    footer: false,
    isOpen: true,
    onClose: onClose,
    title: "Offers",
    children: [promos.map(function (promo) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: _promoMessagesModule.default['promo--plain'],
        "data-testid": "product-card-promo-message",
        children: promo
      }, promo);
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
      href: productUrl,
      onClick: function onClick() {
        return (0, _noScroll.setNoScroll)(false);
      },
      tag: "a",
      children: "View full product information"
    })]
  });
};